<template>
  <button type="button" class="btn-white">
    <i class="fa-solid fa-pen" />
    <span class="space-icon" />{{ label }}
  </button>
</template>

<script>
export default {
  name: "EditButton",
  props: ["label"],
};
</script>